import React, { useState, useEffect } from "react";
import { T } from "../../hooks/useTranslate";

import { Box, Typography } from "@mui/material";

import { ReferralsCopyBox } from "../../components/ReferralsCopyBox";
import { ReferralsAlert } from "../../components/ReferralsAlert";
import { ReferralsLink } from "../../components/ReferralsLink";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useAuth } from "../../hooks/useAuth";

const FeelGreatSection = ({ referralCode }) => {
  const [link, setLink] = useState("Loading...");
  const [showCode, setShowCode] = useState(false);

  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));

  const { userInfo } = useAuth();

  const handleToggle = () => {
    setShowCode(!showCode);
  };

  const toggleText = showCode ? <T>show_link</T> : <T>show_code</T>

  useEffect(() => {
    if (referralCode) {
      setLink(`${process.env.REACT_APP_FEEL_GREAT_REFERRAL_URL}/${referralCode}`);
    } else {
      setLink(`${process.env.REACT_APP_FEEL_GREAT_REFERRAL_URL}/${userInfo.unicityId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralCode]);

  return (
    <Box sx={{ marginBottom: "32px", padding: "0px 32px" }}>
      <ReferralsAlert />
      <Typography variant="h3" sx={{ marginBottom: "8px" }}>
        <T>feel_great</T>
      </Typography>
      <Typography variant="h5" sx={{ marginBottom: "24px" }}>
        <T>feel_great_subtext</T>
      </Typography>
      {viewportIsSmall ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: "24px" }}>
          <ReferralsCopyBox text={showCode ? referralCode : link} />
          <ReferralsLink
            text={toggleText}
            handleToggle={handleToggle}
          />
        </Box>
      ) : (
        <Box>
          <Box sx={{ marginBottom: "16px" }}>
            <ReferralsCopyBox text={showCode ? referralCode : link} />
          </Box>
          <ReferralsLink
            text={toggleText}
            handleToggle={handleToggle}
          />
        </Box>
      )}
    </Box>
  );
};

export { FeelGreatSection };
